var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 556 431"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9E0F4",
    fillRule: "nonzero",
    d: "M419 416c46.28-21.447 200.192-195.208 107.168-221.133-39.347-10.985-82.223 39.766-95.803-35.591-7.698-42.842 39.241-94.581 20.743-135.446-23.202-51.3-68.965-7.36-88.746 23.838-18.07 28.451-30.794 105.896-75.915 68.766C256.402 91.718 272.44 8.012 215.45 9.88c-62.122 1.977-14.328 87.551-38.172 113.476-28.227 30.758-37.423-36.47-87.676-26.364-47.154 9.447-30.046 49.103-14.114 82.387 29.831 61.846 25.554 58.77-20.636 49.213-65.758-13.621-64.796 28.891-35.392 61.077 23.202 25.376 41.914 54.816 56.562 86.343 12.617 27.353 41.914 54.266 108.206 54.266 32.441 0 148.866-1.269 182.772-.277 21.777.637 30.27-3.93 52-14z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#018AFC",
    fillRule: "nonzero",
    d: "M402.458 398.406c27.587-31.346 101.577-80.88 87.357-140.79-6.95-29.207-19.888-14.55-42.663-14.764-110.665-1.177 12.51-145.818-61.374-148.707-47.153-1.818-42.234 72.963-70.676 88.904-35.712 20.112-37.316-30.812-48.757-51.566-19.139-34.77-46.19-41.617-60.839-3.103-14.007 36.481 17 74.888-34.43 55.952-24.591-9.093-69.5-40.974-68.216 10.27.535 20.22 44.908 40.12 31.65 62.907-12.19 20.969-70.356-14.015-55.066 27.174 6.094 16.475 36.888 18.936 42.662 34.234 5.56 14.871-7.912 18.08-6.736 28.565 5.88 53.278 92.275 43.97 133.654 50.71 37.53 6.205 116.653 42.259 153.434.214z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C80C1",
    d: "M402.458 398.406c27.587-31.346 101.577-80.88 87.357-140.79-6.95-29.207-19.888-14.55-42.663-14.764-110.665-1.177 12.51-145.818-61.374-148.707-47.153-1.818-42.234 72.963-70.676 88.904-35.712 20.112-37.316-30.812-48.757-51.566-19.139-34.77-46.19-41.617-60.839-3.103-14.007 36.481 17 74.888-34.43 55.952-24.591-9.093-69.5-40.974-68.216 10.27.535 20.22 44.908 40.12 31.65 62.907-12.19 20.969-70.356-14.015-55.066 27.174 6.094 16.475 36.888 18.936 42.662 34.234 5.56 14.871-7.912 18.08-6.736 28.565 5.88 53.278 92.275 43.97 133.654 50.71 37.53 6.205 116.653 42.259 153.434.214z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCB315",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: "M280.887 370.697c-63.192 12.838-116.44 13.373-118.899 1.177-1.496-7.168 14.756-17.01 41.059-26.532"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCB315",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    d: "M358.62 316.564c18.925.214 31.115 3.102 32.184 8.772 2.46 12.197-46.726 32.523-109.917 45.361"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70CAF2",
    d: "M225.073 148.493s-3.742-4.6-23.202-2.14c-18.177 2.247-22.026 23.965-22.989 31.667-1.71 13.052-.748 41.296-.534 54.455.214 10.698 1.71 20.862 4.384 30.597 4.276 15.192 13.258 34.235 15.076 56.166 4.597 55.097-2.032 110.728-2.032 110.728h171.29s-5.987-54.99.429-108.802c2.459-21.183 12.403-39.69 17.856-54.24 2.78-7.49 4.918-13.373 5.774-16.369l1.603-5.35c3.636-11.981 4.812-24.605 2.887-37.015-.962-6.205-24.164-66.437-53.247-59.483-4.705 1.177-8.02 4.386-8.661 7.703-1.497 8.558 4.277 16.69 6.63 21.182l3.42 12.303-118.684-41.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3543",
    d: "M347.18 165.29l-3.53 17.866-115.797 6.419-1.176 30.169s33.68 2.46 58.38 22.466c0 0 18.605-21.824 73.242-35.946l-13.793-22.895",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#535EAA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M249.558 319.131c11.655 5.884 42.663 5.243 55.387 0m-77.947-99.387c17.428-.428 40.31 10.163 58.059 22.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70CAF2",
    fillRule: "nonzero",
    d: "M305.158 138.971c-2.352-10.591-16.252-16.903-26.41-13.052-10.157 3.852-13.579 8.666-14.648 21.397-.855 10.805.214 66.758 2.887 72 4.384 8.666 12.296 14.657 21.064 13.8 8.767-.748 15.397-8.558 17.856-20.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70CAF2",
    fillRule: "nonzero",
    d: "M265.383 139.185s-3.742-13.8-26.09-9.628c-22.774 4.28-14.113 63.013-12.83 75.316.642 6.205 1.604 11.768 5.988 16.155 4.49 4.386 9.088 6.74 15.29 6.419 9.516-.535 16.894-8.773 17.642-15.192"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#535EAA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M363.538 206.05s-62.015 10.163-86.18 45.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70CAF2",
    fillRule: "nonzero",
    d: "M359.475 185.188c-.32-11.126-6.95-46.965-15.29-54.454-9.943-8.88-26.303-8.987-34.963-.535-7.378 7.168-3.743 43.542-3.743 43.542s-.534 20.862.963 34.342c.748 6.419 6.415 18.4 16.252 18.187 27.372-.428 20.957-43.114 20.957-43.114l15.824 2.032z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#535EAA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.172 165.075s-.962 42.152 2.78 50.069c2.673 5.563 8.875 8.986 15.29 8.986 9.41 0 17.001-5.777 15.076-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.073 148.493c-.641 36.481-1.176 36.588 1.39 56.273.855 6.205 3.208 23.109 21.385 23.109 14.114 0 17.963-15.834 17.963-15.834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.848 138.757s-.641 71.572 2.353 80.452c2.78 8.345 10.264 14.336 21.064 13.8 15.076-.748 19.032-18.935 17.535-32.308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.335 208.19c.748 3.744 2.031 12.73 10.692 16.582 7.27 3.317 15.825.963 20.53-3.744 8.767-8.88 5.452-39.37 5.452-39.37m-38.064-42.687l.748 40.333c0 2.46.214 26.425.642 28.779"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#535EAA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M334.99 154.163c-4.063 7.06 5.56 23.536 5.56 23.536l17.75 28.351"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCB315",
    fillRule: "nonzero",
    d: "M196.525 384.926c-36.247 0-38.065-9.2-38.707-12.196a4.316 4.316 0 013.315-5.028 4.314 4.314 0 015.025 3.316c.214 1.177 6.523 5.67 32.505 5.456 22.24-.214 51.11-3.744 81.369-9.842 30.259-6.205 58.273-14.229 78.802-22.68 24.058-9.95 28.014-16.476 27.8-17.653a4.316 4.316 0 013.314-5.028 4.314 4.314 0 015.026 3.317c.641 3.102 2.566 12.624-32.826 27.173-20.956 8.666-49.505 16.904-80.406 23.216-30.794 6.312-60.304 9.842-82.972 10.056-.748-.107-1.497-.107-2.245-.107z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.354 54.562)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4C80C1",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M451.215 282.543c-.32-.963-.534-1.926-.534-2.995a8.125 8.125 0 018.126-8.131 8.125 8.125 0 018.126 8.13 8.125 8.125 0 01-8.126 8.131h-.962c-2.994-.32-5.24-2.246-6.416-4.921M169.366 11.661c-.32-.963-.534-1.926-.534-2.995a8.125 8.125 0 018.126-8.131 8.125 8.125 0 018.126 8.13 8.125 8.125 0 01-8.126 8.131h-.963c-2.993-.32-5.239-2.246-6.415-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ED2E89",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M427.692 52.422c-1.39 0-2.245-1.498-1.497-2.675l7.699-12.196.107-.107c.427-.642 1.069-.963 1.817-.963.749 0 1.39.428 1.818.963l7.378 11.661c.428.642.428 1.498.107 2.247-.428.749-1.07 1.177-1.925 1.177h-15.504v-.107z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCB315",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M469.518 159.06c-1.39 0-2.246-1.497-1.497-2.674l7.698-12.196.107-.107c.428-.642 1.07-.963 1.818-.963s1.39.428 1.818.963l7.377 11.661c.428.642.428 1.498.107 2.247-.428.749-1.07 1.176-1.924 1.176h-15.504v-.106z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4C80C1",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M484.845 169.405h-4.918a1.69 1.69 0 01-1.71-1.712v-12.731c0-1.176.961-2.246 2.245-2.246h12.189c1.176 0 2.245.963 2.245 2.246v12.197c0 1.176-.962 2.246-2.245 2.246h-7.806z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCB315",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M26.624 264.89h-4.919a1.69 1.69 0 01-1.71-1.71v-12.733c0-1.177.962-2.247 2.245-2.247h12.19c1.175 0 2.245.963 2.245 2.247v12.196c0 1.177-.963 2.247-2.246 2.247h-7.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.736 149.456v-13.48M0 142.716h13.472",
    stroke: "#535DAA",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46 30.17V16.797m-6.736 6.633h13.472",
    stroke: "#33BBA3",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.278,
    cy: 20.541,
    fill: "#70CAF2",
    fillRule: "nonzero",
    rx: 2.887,
    ry: 2.889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.892 280.083v-13.48m-6.737 6.74h13.473",
    stroke: "#ED2E89",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 359.689,
    cy: 245.955,
    fill: "#70CAF2",
    fillRule: "nonzero",
    rx: 2.887,
    ry: 2.889
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.675,
    cy: 20.541,
    fill: "#ED2E89",
    fillRule: "nonzero",
    rx: 2.887,
    ry: 2.889
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.282,
    cy: 302.977,
    fill: "#33BBA3",
    fillRule: "nonzero",
    rx: 2.887,
    ry: 2.889
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M233 376.25c-1.705.2-3.295.3-5 .5M305 363c-7.441 1.805-15.098 3.504-22.97 4.991-14.883 2.974-29.334 5.31-43.03 7.009"
  }))));
}
export default SvgHand;